import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Location } from '@angular/common';
import { NotificationService } from '../../services/notification.service';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { AmplifyAuthService } from '../../services/amplify-auth.service';

@Component({
    selector: 'app-activate',
    templateUrl: './activate.component.html',
    styleUrls: ['./activate.component.scss'],
    standalone: false
})
export class ActivateComponent implements OnInit {
  isLoading = false;
  private isSendingVerificationCode = false;
  activateForm: UntypedFormGroup;
  locationState;
  private username;
  private password;
  maskedDestination: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private readonly dialog: MatDialog,
    private location: Location,
    private notificationService: NotificationService,
    private authService: AuthService,
    private router: Router,
    private amplifyAuth: AmplifyAuthService
  ) {
    this.locationState = this.location.getState();
    this.activateForm = this.buildForm();
  }

  ngOnInit() {
    this.username = this.locationState ? this.locationState.username : null;
    this.password = this.locationState ? this.locationState.retryPassword : null;
    this.resendConfirmationCode();
  }

  buildForm(): UntypedFormGroup {
    return this.formBuilder.group({
      confirmationCode: new UntypedFormControl('', [Validators.required, Validators.minLength(6)]),
    });
  }

  activateAccount() {
    this.isLoading = true;
    this.amplifyAuth.confirmSignUp({
      username: this.username,
      confirmationCode: this.activateForm.get('confirmationCode').value,
      options: {
        clientMetadata: { 'auth-session-id': sessionStorage.getItem('auth-session-id') },
      },
    })
      .then(() => {
        this.isLoading = false;
        this.loginActiveAccount();
      })
      .catch((error) => {
        this.isLoading = false;
        if (error.name === 'UserLambdaValidationException') {
          this.loginActiveAccount();
        } else {
          this.notificationService.displayClientError(error);
        }
      });
  }

  resendConfirmationCode() {
    if (this.isSendingVerificationCode) {
      this.notificationService.displayInfo('You can only request one confirmation code every 60 seconds.');
      return;
    }
    this.isSendingVerificationCode = true;
    this.amplifyAuth.resendSignUpCode({ username: this.username })
      .then((data: any) => {
        this.maskedDestination = data.destination;
        this.notificationService.displayInfo(`A code was sent to ${this.maskedDestination}.`);
        setTimeout(() => {
          this.isSendingVerificationCode = false;
        }, 60000);
      })
      .catch((error) => {
        this.isSendingVerificationCode = false;
        this.notificationService.displayClientError(error);
      });
  }

  loginActiveAccount() {
    this.isSendingVerificationCode = true;
    this.notificationService.displayInfo('Account has been activated.');
    this.authService
      .login(this.username, this.password)
      .then((user: any) => {
        this.isSendingVerificationCode = false;
        this.router.navigate(['/redirect']);
      })
      .catch((error: any) => {
        this.isSendingVerificationCode = false;
        this.notificationService.displayClientError(error);
        this.router.navigate(['/login']);
      });
  }
}
